export default from './AuthenticationHeader';


// WEBPACK FOOTER //
// ./js/components/AuthenticationHeader/index.js